<div class="row">
    <div class="col-16">
        <p><strong>Paperless Settings</strong></p>
    </div>
    <div class="col-16">
        <!--<p><strong>Get the benefit of paperless documents</strong></p>-->
        <p>
            Once your application is complete, would you like to receive Medicare Part D documents electronically? This lets you keep your documents organized in one secure online location that’s always accessible.
        </p>
        <div class="row">
            <br />
        </div>
        <p>
            The types of documents include evidence of coverage, your formulary, a pharmacy directory, explanation of benefit statements, plan coverage information, billing information and general plan information and messaging. You can go back to mailed versions at any time.
        </p>

    </div>

</div>
<div class="row">
    <br />
</div>

    <div class="row">
        <div class="col-16">
            <!--<div class="bottom-20">
        <p><strong>Do you want paperless documents?</strong></p>
    </div>-->
            <!--<div class="bottom-20">
        <ValidatedRadioButtonGroup [label]="''"
                                   [options]="eobOptions"
                                   [selectedValue]="eobOption"
                                   [radioGroupName]="'eobOptions'"
                                   (onValueChange)="eobOptionChanged($event)">
        </ValidatedRadioButtonGroup>
    </div>-->
            <div class="bottom-20">
                <ValidatedCheckbox [id]="'EOBoption'"
                                   [label]="'Yes, I want to go paperless for all available and future documents.'"
                                   [checked]="enroll.EOB"
                                   (onValueChange)="eobOptionChanged($event)">
                </ValidatedCheckbox>
            </div>
        </div>
    </div>


<div class="row">
    <div class="col-8">
        <div class="bottom-20">
            <label>{{emailLabel}}</label>
            <ValidatedTextField [text]="email"
                                (onValueChange)="emailChanged($event)"
                                [validators]="[]"
                                [disabled]="EOBEmaildisabled">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <p>
                Once you enroll, or if you are already a returning member, you can go back to mailed versions at any time on Caremark.com.
            </p>
        </div>
    </div>
</div>
<!--<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <p>
                The Explanation of Benefits (EOB) is a record of your prescription claims that have been processed for the month. The EOB statement shows each prescription’s cost,
                the amount your plan has paid toward its cost, and the amount for which you’re responsible. You can change your preference on caremark.com at any time.
            </p>
            <p>
                If you choose to receive paperless Explanation of Benefit statements, you will need to create an account on Caremark.com.
                In addition to viewing your EOB statements online, Caremark.com will give you the ability to track your prescription costs and order mail service prescriptions.
            </p>
        </div>
    </div>
</div>-->
